export default __webpack_public_path__ + "static/media/edited-16.b9ea1a64.jpg";